import { forwardRef } from 'react';
import { Alert, AlertProps } from '@mui/material';
import { CustomContentProps, SnackbarContent, useSnackbar } from 'notistack';

interface SnackbarAlertProps extends CustomContentProps {
  severity?: AlertProps['severity'];
}

const SnackbarAlert = forwardRef<HTMLDivElement, SnackbarAlertProps>((props, ref) => {
  const {
    // Destructure props used in component
    id,
    message,
    severity,
    variant,
    // Destructure props to exclude from DOM (fix console warnings)
    persist,
    anchorOrigin,
    autoHideDuration,
    hideIconVariant,
    iconVariant,
    ...other
  } = props as any; // Type assertion needed due to dynamic nature of notistack props

  const { closeSnackbar } = useSnackbar();

  // Mapping notistack variants to MUI Alert severities
  const alertSeverity = (severity ||
    (variant === 'default' ? 'info' : variant)) as AlertProps['severity'];

  return (
    <SnackbarContent ref={ref} role="alert" {...other}>
      <Alert
        severity={alertSeverity}
        variant="filled"
        onClose={() => closeSnackbar(id)}
        sx={{
          width: '100%',
          boxShadow: (theme) => (theme as any).vars.shadows[4],
          '& .MuiAlert-message': {
            fontSize: '0.95rem',
            fontWeight: 600,
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          },
          '& .MuiAlert-icon': {
            fontSize: 24,
            opacity: 1,
          },
        }}
      >
        {message}
      </Alert>
    </SnackbarContent>
  );
});

export default SnackbarAlert;
